import "./IntelligenceEngine.module.css";
import Header from "@/reusable_sections/Header";
import FutureProofingSmbs from "./sections/FutureProofingSmbs";
import ComputeInfrastructureStats from "./sections/ComputeInfrastructureStats";
import TheComputeFirstStrategy from "./sections/TheComputeFirstStrategy";
import OurInfrastructureAssets from "./sections/OurInfrastructureAssets";
import TheDeploymentPipeline from "./sections/TheDeploymentPipeline";
import StrategicAlliances from "./sections/StrategicAlliances";
import InstitutionalGateway from "./sections/InstitutionalGateway";
import NeuralInfrastructure from "./sections/NeuralInfrastructure";
import Footer from "@/reusable_sections/Footer";
import AccessAndInstallation from "./sections/AccessAndInstallation";
import TechnicalProcess from "./sections/TechnicalProcess";
export default function IntelligenceEnginePage() {
  return <div>
      <Header />
      <FutureProofingSmbs />
      <ComputeInfrastructureStats />
      <NeuralInfrastructure />
      <AccessAndInstallation />
      <TechnicalProcess />
      <OurInfrastructureAssets />
      <TheDeploymentPipeline />
      <StrategicAlliances />
      <InstitutionalGateway />
      <Footer />
    </div>;
}